import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { logout } from '../Actions/Auth';
import { Navigate } from 'react-router-dom';
import Bookings from '../BookingHistory/Bookings';
import { BiLogOut } from "react-icons/bi";
import BreathEV_Logo from '../Images/BreatheEV_Logo[Icon]_RGB[Black].png'
import Image from 'react-bootstrap/Image';
import { BiSolidWallet } from 'react-icons/bi';
import { Modal, Form, Input, Button } from 'antd';
import { BreathAPIs } from '../APIs/BreathAPIs';
import StripePayment from '../StripePayment/StripePayment';
import PaymentHistory from '../StripePayment/PaymentHistory';
import styles from './style.module.css';


const NavCustom = ({isAuthenticated, loading, user, logout, type, balance, jwt}) => {

  const [historyModal, setHistoryModal] = useState(false)
  const [walletModal, setWalletModal] = useState(false)
  const [walletRechargeModal, setWalletRechargeModal] = useState(false)
  const [amount, setAmount] = useState(0)

  const addAmountToWallet = async ()=>{
    balance += Number(amount)
    let finalAmount = {'amount': balance}
   const res =  await BreathAPIs.updateWallet(jwt, finalAmount)
   if (res.status === 200){
    setWalletRechargeModal(!walletRechargeModal)
    window.location.replace("/")
   }
  }

  // console.log(user)
  // console.log(type)
  const onLogOut = () =>{
    logout() 
    if(isAuthenticated === false){
      return <Navigate to='/'></Navigate>
    }
  }
  return (
    <div className={styles.TopNavDiv}>
    <div className={styles.NavDiv}>
      {/* <Container> */}
       {isAuthenticated && <Navbar collapseOnSelect expand="lg" variant="dark" className={styles.NavHead}>
      <Container>
        <Navbar.Brand href= {(type === "User") ? "/" : "/adminDashboard"}>
        <Image src={BreathEV_Logo} alt="BreatheEV Logo" width={50} height={30} className="d-inline-block align-top" />
          {' '}
          
          
          </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#features">Welcome {user}</Nav.Link>
          </Nav>
          <Nav>
          <Nav.Link>
          <BiSolidWallet onClick={()=>setWalletModal(!walletModal)} /> {balance?.toFixed(2)}
            </Nav.Link>
           
          </Nav>
          <Nav>
            {(type === "User") && <Nav.Link href='/bookingHist'>
              View Bookings
            </Nav.Link>}
          </Nav>

          <NavDropdown title={user}>
              <NavDropdown.Item href="/profile">My profile</NavDropdown.Item>
              <NavDropdown.Item onClick={onLogOut} href="/">Logout</NavDropdown.Item>
          </NavDropdown>

          
        </Navbar.Collapse>
      </Container>
    </Navbar>}
    {/* </Container> */}
    {!isAuthenticated && <Navbar collapseOnSelect expand="lg" bg="primary" variant="dark">
      <Container>
        <Navbar.Brand href="/">
        <Image src={BreathEV_Logo} alt="BreatheEV Logo" width={50} height={30} className="d-inline-block align-top" style={{ marginRight: '-10px' }} />
          {' '}
 
          
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="#features">Home</Nav.Link>
            {/* <Nav.Link href="#pricing">Pricing</Nav.Link> */}
          </Nav>
          {/* <Nav>
            <Nav.Link href="">Sign Up</Nav.Link>
            <Nav.Link eventKey={2} href="#memes">
              Log In
            </Nav.Link>
          </Nav> */}
          <Nav>
            <Nav.Link href="/login" >Log In</Nav.Link>
            <Nav.Link href="/registration" >Sign Up</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>}

    <Modal open={walletModal} onCancel={()=>{setWalletModal(!walletModal)}} 
            okText="Add Amount" onOk={()=>{setWalletModal(!walletModal); setWalletRechargeModal(true)}}
             footer={[<Button onClick={()=>{setHistoryModal(!historyModal)}}>History</Button>,
                      <Button onClick={()=>{setWalletModal(!walletModal); setWalletRechargeModal(true)}}>Add Amount</Button>,
                      <Button onClick={()=>{setWalletModal(!walletModal)}}>Cancel</Button>]
            }
            >
      <div>
        <p>Balance: {balance?.toFixed(2)}</p>
      </div>
  </Modal>
  <Modal open={walletRechargeModal} onCancel={()=>{setWalletRechargeModal(!walletRechargeModal)}} footer={null}>
        <StripePayment/>
  </Modal>
  <Modal open={historyModal} onCancel={()=>{setHistoryModal(!historyModal)}} footer={<Button onClick={()=>{setHistoryModal(!historyModal)}}>Cancel</Button>}>
            <PaymentHistory></PaymentHistory> 
  </Modal>
  {/* <Modal open={walletRechargeModal} onCancel={()=>{setWalletRechargeModal(!walletRechargeModal)}} onOk={()=>addAmountToWallet()} footer={null}>
        <h5>Top Up your Wallet</h5>
        <Form onFinish={()=>addAmountToWallet()}>
                <Form.Item label="Amount" name="amount" rules={[{ required: true, message: "Please enter a amount!" }]}>
                    <Input placeholder="Enter the amount" onChange={(e)=>{setAmount(e.target.value)}}/>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Add Amount</Button>
                </Form.Item>
        </Form>
  </Modal> */}
    
  </div>
  </div>
  )
}
NavCustom.propTypes={ 
  logout: PropTypes.func.isRequired,
  isAuthenticated:PropTypes.bool,
  loading:PropTypes.bool,
  balance: PropTypes.number,
  jwt: PropTypes.string
}
const mapStateToProps = state =>({
  isAuthenticated : state.auth.isAuthenticated,
  loading: state.auth.loading,
  balance: state.auth && state.auth.user ? state.auth.user.wallet.coins: null,
  jwt: state.auth  ? state.auth.token: null
})


export default connect(mapStateToProps,{logout})(NavCustom)



{/* <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown> */}